// extracted by mini-css-extract-plugin
module.exports = {"closeXHoverParent":"layouts_closeXHoverParent__2nqYU","closeXButton":"layouts_closeXButton__1rKAf"};